<template>
<div v-bind:class="{'field-invalid': invalid, 'field-valid': valid, 'field-required': required}">
  <label v-if="label">{{label}}</label>
  <slot></slot>
  <div class="field-note">
    <slot name="note"></slot>
  </div>
  <div>
    <span class="field-txt-invalid">{{message}}</span>
  </div>
</div>
</template>

<script>
export default {
  name: "valid-field",
  props: ['label', 'v', 'bSuccess', 'bInvalid'],
  computed: {
    message() {
      if (typeof this.v !== "undefined") {

        if (this.v.alpha !== "undefined")
          if (this.v.alpha === true) {
            if (this.v.$model) {
              this.v.$model = this.v.$model.replace(/[0-9]/g, '');
            }
          }

        if (this.bSuccess)
          this.valid = !this.v.$invalid;

        if (this.bInvalid)
          this.invalid = this.v.$error;

        this.required = this.v.$params.required;

        if (this.v.$error) {
          for (let key in this.$options.messages) {
            if (this.v[key] === false) {
              return this.$options.messages[key](this.v)
            }
          }
        } else {
          return null
        }
      }
    },
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  messages: { //Add more messages here when you need, the key should be the same as the name of the validator
    required: v => 'Campo obrigatório!',
    email: v => 'E-mail inválido.',
    alphaNum: v => 'Apenas letras e números.',
    minLength: v => 'Por favor, utilize no mínimo ' + v.$params.minLength.min + ' caracteres',
    maxLength: v => 'Por favor, utilize no máximo ' + v.$params.maxLength.min + ' caracteres',
    sameAs: v => 'Valor deve ser igual ao ' + v.$params.sameAs.eq,
    between: v => "Valor deve estar entre ",
    alpha: v => "Apenas letras.",
    numeric: v => "Apenas números."
  },
  data() {
    return {
      invalid: '',
      valid: '',
      required: ''
    }
  }
}
</script>

<style lang="scss">
$error-color: #ec5956;
$success-color: #00A651;
$input-color: #d3d3d3;

input {
  border: 1px solid $input-color;
}

/* Success */
.field-valid {
  input {
    border-color: $success-color !important;
  }

  label::after {
    color: $success-color;
  }
}

/* Error */
.field-invalid {
  color: $error-color;

  input {
    border-color: $error-color !important;
  }
}

.field-txt-invalid {
  color: $error-color;
  font-size: 12px;
}

/* Required */
.field-required label::after {
  content: '*';
  color: $error-color;
}

/* Note */
.field-note {
  font-size: 12px;
}

button.invalid {
  opacity: 0.5;
  -webkit-filter: grayscale(100%);
  cursor: no-drop !important;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/validField.vue